export const translations = {
  en: {
    nav: {
      instagram: "Instagram",
      lang: "RU",
    },
    hero: {
      location: "Ubud, Bali · Private Estate",
      brand: "A M M É",
      tagline: "A silence you can",
      taglineItalic: "step into.",
      subtitle:
        "Deep in the mist of Payangan, where stone meets water and the jungle wraps around, a home built for one thing — peace.",
      scroll: "Scroll",
    },
    philosophy: {
      label: "The Estate",
      heading: "Balinese wisdom,",
      headingItalic: "quietly spoken.",
      body: "This place speaks its own language — unhurried, wordless. AMMÉ is tucked into the green north of Ubud. Here, we don't count hours. We learn to breathe slower, to hear ourselves, to live in a rhythm the city long forgot. Walls dissolve into forest; an ordinary day becomes a ritual of its own.",
      body2:
        "A sanctuary for those seeking clarity of mind, lightness of body, and the beauty of unhurried time.",
    },
    setting: {
      label: "The Setting",
      heading: "A home",
      headingItalic: "dissolved into the forest.",
      body: "The estate is nestled in the quiet of the Payangan jungle. Simple, restrained architecture doesn't argue with nature — it yields to it, dissolving into the living breath of the island.",
      features: [
        "Six bedrooms, looking only onto the canopy",
        "Ozone salt-water infinity pool",
        "Sauna, ice bath & fire pit",
        "Spa complex",
        "A trail straight into the jungle, to the river",
      ],
      quote: "The body knows how to heal itself. We just create the conditions.",
    },
    rooms: {
      label: "The Spaces",
      items: [
        {
          title: "Bedrooms",
          desc: "Six spacious rooms where the jungle is part of the interior.",
        },
        {
          title: "Infinity Pool",
          desc: "Ozone salt-water, meeting the horizon.",
        },
        {
          title: "Sauna",
          desc: "Pine and glass, the warmth of an iron stove — and the forest right before your eyes. The cold plunge waits a few steps away.",
        },
        {
          title: "Spa Complex",
          desc: "A space made for the body to recover. Warm water, gentle stillness, and slow, uninterrupted time.",
        },
        {
          title: "Jungle & River",
          desc: "A path leads straight into the wild — to the sound of water and ancient trees.",
        },
      ],
    },
    inclusions: {
      label: "The Feeling",
      heading: "How time",
      headingItalic: "flows here.",
      items: [
        {
          title: "Morning",
          desc: "Light through the canopy. Stone still holding the volcanic cool of the night.",
        },
        {
          title: "Water",
          desc: "The pool at the cliff's edge sounds like a quiet, endless melody.",
        },
        {
          title: "Materials",
          desc: "Raw concrete, hand-laid teak, warm wood under bare feet.",
        },
        {
          title: "Evening",
          desc: "Candlelight at dusk. Conversations without phones — long and real.",
        },
        {
          title: "Heat & Ice",
          desc: "The cedar warmth of the sauna, the ice plunge — and the pause between, where you hear your own breath.",
        },
        {
          title: "Balinese Ritual",
          desc: "Offerings placed daily. Incense and frangipani — this is how the island cares for its guests.",
        },
        {
          title: "Food",
          desc: "Simple, seasonal, cooked slowly and served under open skies.",
        },
        {
          title: "The Forest",
          desc: "River bathing, paths among old trees, silence you cannot buy.",
        },
        {
          title: "Solitude & Closeness",
          desc: "You can be silent — if you want to. You can be near someone — if it's easier. Here, no one has to prove anything.",
        },
      ],
    },
    founder: {
      label: "Emma",
      quote: "I welcome you with an open heart — inviting you to look deeper, into yourself.",
      quote2: "I welcome you with an open heart — inviting you to look deeper, into yourself.",
      name: "Emma",
      handle: "@emmamur",
      role: "Founder of AMMÉ",
      bio1: "My path began in Yessentuki, where care for health was part of everyday life. Then came years of work in pharmacology, life in America, and travels around the world in search of the best restorative practices.",
      bio2: "It was in Bali that the feeling of home was born — one that brings together nature, comfort, and care for the person.",
      bio3: "And so AMMÉ appeared — a place people come to slow down, restore their strength, and feel in harmony with themselves again.",
      bio4: "",
      sign: "With love, Emma",
    },
    cta: {
      label: "For guests",
      heading: "Arrive as a guest.",
      headingItalic: "Leave as yourself.",
      body: "We reply to every message personally — on Instagram, WhatsApp, or by email.",
      instagram: "Message on Instagram",
      whatsapp: "WhatsApp",
      email: "Email us",
    },
    footer: {
      brand: "A M M É",
      tag: "Private Estate · Ubud, Bali",
      links: "Follow the journey",
      rights: "© 2026 AMMÉ Estate. All rights reserved.",
      founded: "Founded by Emma Mur",
    },
  },
  ru: {
    nav: {
      instagram: "Instagram",
      lang: "EN",
    },
    hero: {
      location: "Убуд, Бали · Приватное поместье",
      brand: "A M M É",
      tagline: "Тишина, в которую",
      taglineItalic: "хочется возвращаться.",
      subtitle:
        "Среди туманных джунглей Бали находится AMMÉ — место, где время замедляется, а природа помогает восстановить силы и почувствовать внутреннее равновесие. Здесь нет спешки, шума и суеты. Только тишина, свежий воздух, тропический лес и пространство, созданное для отдыха.",
      scroll: "Листать",
    },
    philosophy: {
      label: "Философия",
      heading: "Философия",
      headingItalic: "AMMÉ.",
      body: "AMMÉ — это место, где можно ненадолго выйти из привычного ритма и посвятить время себе.",
      body2:
        "Утро начинается с пения птиц, день проходит среди джунглей, а вечера наполнены теплом, живым общением и ощущением полного спокойствия. Каждая деталь здесь создана для того, чтобы вы могли расслабиться, восстановить силы и насладиться моментом.",
    },
    setting: {
      label: "Вилла",
      heading: "Вилла среди",
      headingItalic: "джунглей.",
      body: "AMMÉ расположен в районе Паянган — одном из самых живописных мест Бали. Архитектура виллы гармонично вписана в окружающий ландшафт. Натуральное дерево, камень, стекло и открытые пространства стирают границу между домом и природой.",
      features: [
        "Шесть просторных спален с видом на джунгли",
        "Инфинити-бассейн с озонированной солёной водой",
        "Кедровая баня с чугунной печью",
        "Ледяная купель",
        "SPA-комплекс",
        "Зона у костра",
        "Тропа к реке через джунгли",
      ],
      quote:
        "Я мечтала создать место, где человек сможет остановиться, восстановить силы и снова почувствовать связь с собой.",
    },
    rooms: {
      label: "Пространство",
      items: [
        {
          title: "Спальни",
          desc: "Шесть просторных комнат с панорамными окнами, натуральными материалами и видом на тропический лес. Интерьеры наполнены естественным светом и ощущением уединения.",
        },
        {
          title: "Инфинити-бассейн",
          desc: "Бассейн с озонированной солёной водой расположен на краю склона, открывая панорамный вид на бескрайние джунгли.",
        },
        {
          title: "Кедровая баня",
          desc: "Кедровая баня с чугунной печью, ледяная купель и терраса с видом на джунгли создают идеальное пространство для отдыха и восстановления.",
        },
        {
          title: "SPA",
          desc: "Место, где можно полностью расслабиться, восстановить силы и уделить время себе. Здесь всё располагает к спокойствию и заботе о теле.",
        },
        {
          title: "Джунгли и река",
          desc: "От виллы начинается тропа, ведущая к реке. Прогулка среди тропического леса позволяет почувствовать настоящую природу Бали и насладиться тишиной.",
        },
      ],
    },
    inclusions: {
      label: "Атмосфера",
      heading: "Атмосфера",
      headingItalic: "AMMÉ.",
      items: [
        {
          title: "Утро",
          desc: "Солнечный свет пробивается сквозь густые кроны деревьев, а прохладный утренний воздух наполняет пространство свежестью.",
        },
        {
          title: "Вода",
          desc: "Шум воды сопровождает вас в течение дня, создавая ощущение покоя и гармонии.",
        },
        {
          title: "Вокруг",
          desc: "Натуральный камень, дерево, стекло и природные фактуры делают пространство тёплым, лаконичным и уютным.",
        },
        {
          title: "Вечер",
          desc: "Мягкий свет, ужин под открытым небом, неспешные разговоры и ощущение, что время остановилось.",
        },
        {
          title: "Баня и ледяная купель",
          desc: "Контраст тепла и холода помогает расслабиться, восстановить силы и почувствовать прилив энергии.",
        },
        {
          title: "Балийские традиции",
          desc: "Каждое утро начинается с традиционных подношений. Аромат благовоний и цветов франжипани напоминает о культуре острова и уважении к природе.",
        },
        {
          title: "Кухня",
          desc: "Свежие сезонные продукты, простые блюда и неспешные ужины в окружении джунглей.",
        },
        {
          title: "Природа",
          desc: "Тропический лес, река, пение птиц и тишина создают атмосферу, в которой легко отпустить мысли и просто наслаждаться моментом.",
        },
        {
          title: "Время для себя",
          desc: "Проведите день в одиночестве, разделите его с близкими или соберите друзей. В AMMÉ каждый отдых проходит в своём ритме.",
        },
      ],
    },
    founder: {
      label: "Эмма",
      quote:
        "Я мечтала создать место, где человек сможет остановиться, восстановить силы и снова почувствовать связь с собой.",
      quote2:
        "Я мечтала создать место, где человек сможет остановиться, восстановить силы и снова почувствовать связь с собой.",
      name: "Эмма",
      handle: "@emmamur",
      role: "Основательница AMMÉ",
      bio1: "Мой путь начался в Ессентуках, где забота о здоровье была частью повседневной жизни. Позже были годы работы в фармакологии, жизнь в Америке и путешествия по миру в поисках лучших практик восстановления.",
      bio2: "Именно на Бали родилось чувство дома, которое объединяет природу, комфорт и заботу о человеке.",
      bio3: "Так появился AMMÉ — место, куда приезжают, чтобы замедлиться, восстановить силы и вновь почувствовать гармонию с собой.",
      bio4: "",
      sign: "С любовью, Эмма",
    },
    cta: {
      label: "Добро пожаловать",
      heading: "Добро пожаловать",
      headingItalic: "в AMMÉ.",
      body: "Приезжайте за тишиной, отдыхом и впечатлениями, которые останутся с вами надолго. Мы лично отвечаем на каждое сообщение и будем рады помочь организовать ваше пребывание.",
      instagram: "Написать в Instagram",
      whatsapp: "WhatsApp",
      email: "Написать на email",
    },
    footer: {
      brand: "A M M É",
      tag: "Приватное поместье · Убуд, Бали",
      links: "Следите за путешествием",
      rights: "© 2026 AMMÉ Estate. Все права защищены.",
      founded: "Основано Эммой Мур",
    },
  },
};
